import logoImage from '../../assets/img/logo/logo-gein-branco.png';
import SourceLink from '../../components/SourceLink';
import React from 'react';
import {
    MdKeyboardArrowDown,
    MdGroup, MdViewModule, MdDomain, MdAssignment
} from 'react-icons/lib/md';
import {NavLink} from 'react-router-dom';
import {/* UncontrolledTooltip,*/ Collapse, Nav, Navbar, NavItem, NavLink as BSNavLink} from 'reactstrap';
import bn from '../../utils/bemnames';
import {connect} from "react-redux";
import {USER_TYPE} from "../../constants/appConstants";
import {withRouter} from "react-router";

const usersPages = [
    {to: '/admins', name: 'Admin.', exact: false, Icon: MdGroup, level: [USER_TYPE.ADMIN]},
    {to: '/managers', name: 'Gestores', exact: false, Icon: MdGroup, level: [USER_TYPE.ADMIN]},
    {to: '/auditors', name: 'Auditores', exact: false, Icon: MdGroup, level: [USER_TYPE.ADMIN]},
    {to: '/users', name: 'Usuários', exact: false, Icon: MdGroup, level: [USER_TYPE.ADMIN, USER_TYPE.MANAGER]},
];

const navFirstItems = [
    {
        to: '/',
        name: 'Dashboard',
        exact: true,
        Icon: MdViewModule,
        level: [USER_TYPE.ADMIN, USER_TYPE.AUDITOR]
    },
    {
        to: '/audits',
        name: 'Auditorias',
        exact: false,
        Icon: MdAssignment,
        level: [USER_TYPE.ADMIN, USER_TYPE.AUDITOR]
    },
];

const navLastItems = [
    {
        to: '/companies',
        name: 'Empresas',
        exact: false,
        Icon: MdDomain,
        level: [USER_TYPE.ADMIN, USER_TYPE.AUDITOR, USER_TYPE.MANAGER]
    },
];

const bem = bn.create('sidebar');

class Sidebar extends React.Component {
    state = {
        isOpenComponents: false,
        isOpenContents: false,
        isOpenPages: false,
    };

    handleClick = name => () => {
        this.setState(prevState => {
            const isOpen = prevState[`isOpen${name}`];

            return {
                [`isOpen${name}`]: !isOpen,
            };
        });
    };

    render() {
        return (
            <aside className={bem.b()}>
                <div className={bem.e('background')}/>
                <div className={bem.e('content')}>
                    <Navbar>
                        <SourceLink className="navbar-brand d-flex m-auto">
                            <img
                                src={logoImage}
                                className="pr-2"
                                alt=""
                            />
                        </SourceLink>
                    </Navbar>
                    <Nav vertical>

                        {navFirstItems.map(({to, name, exact, Icon, level}, index) => (
                            this.props.user && level.includes(this.props.user.level) &&
                            <NavItem key={index} className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={`navItem-${name}-${index}`}
                                    className=""
                                    tag={NavLink}
                                    to={to}
                                    activeClassName="active"
                                    exact={exact}>
                                    <Icon className={bem.e('nav-item-icon')}/>
                                    <span className="">{name}</span>
                                </BSNavLink>
                            </NavItem>
                        ))}

                        {this.props.user && (this.props.user.level === USER_TYPE.ADMIN || this.props.user.level === USER_TYPE.MANAGER) &&
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Contents')}>
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <MdGroup className={bem.e('nav-item-icon')}/>
                                    <span className="">Usuários</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenContents
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>}
                        <Collapse isOpen={this.state.isOpenContents}>
                            {usersPages.map(({to, name, exact, Icon, level}, index) => (
                                this.props.user && level.includes(this.props.user.level) &&
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        className="ml-2"
                                        tag={NavLink}
                                        to={to}
                                        activeClassName="active"
                                        exact={exact}>
                                        <Icon className={bem.e('nav-item-icon')}/>
                                        <span className="">{name}</span>
                                    </BSNavLink>
                                </NavItem>
                            ))}
                        </Collapse>

                        {navLastItems.map(({to, name, exact, Icon, level}, index) => (
                            this.props.user && level.includes(this.props.user.level) &&
                            <NavItem key={index} className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={`navItem-${name}-${index}`}
                                    className=""
                                    tag={NavLink}
                                    to={to}
                                    activeClassName="active"
                                    exact={exact}>
                                    <Icon className={bem.e('nav-item-icon')}/>
                                    <span className="">{name}</span>
                                </BSNavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
            </aside>
        );
    }
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default withRouter(connect(mapStateToProps)(Sidebar));



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar.js